
export async function openModalByUrlParams(param = 'open-review-form', modalId = 'ratingModal') {
    if (window.location.search.includes(param)) {
        const modalElement = document.getElementById(modalId);
        if (modalElement) {
            let {default: Modal} = await import('bootstrap/js/dist/modal');
            const modal = new Modal(modalElement, {});
            modal.show()
            const closeEl = modalElement.querySelector('[data-bs-dismiss="modal"')
            if (closeEl) {
                closeEl.addEventListener('click', () => {
                    setTimeout(() => document.querySelectorAll('.modal-backdrop').forEach(e => e.remove()), 300)
                    modal.hide()
                })
            }
            modalElement.addEventListener('hide.bs.modal', () => {
                document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
            });
        }
    } else {
        console.error(`ModalInit: not exist modal element with id ${modalId}`)
    }
}